import React, { useEffect, useState } from 'react';
import jackpotImg from './../../../assets/images/png/jackpotImg.png'
import jackpotbg from './../../../assets/images/png/jackpotbg.png'
import FireEmoji from './../../../assets/images/png/fireEmji.png'
import { Link } from 'react-router-dom';

function JackPotSlider({ icon, sectionHeading, TabData, right = false, className }) {
    const [megaJackpot, setMegaJackpot] = useState(0);
    const [minorJackpot, setMinorJackpot] = useState(0);
    const [jpmRace, setJpmRace] = useState(0);

    // Final values for each jackpot
    const finalMegaJackpot = 109240.62;
    const finalMinorJackpot = 391.89;
    const finalJpmRace = 25.00;

    // Maximum increment before subtracting
    const maxMegaIncrement = 500;
    const maxMinorIncrement = 120;
    const maxJpmIncrement = 80;

    useEffect(() => {
        const incrementJackpot = (setJackpot, finalAmount, incrementSpeed, maxIncrement) => {
            let incrementAmount = finalAmount / 100;
            let reachedFinal = false;
            const initialInterval = setInterval(() => {
                setJackpot((prevAmount) => {
                    const newAmount = prevAmount + incrementAmount;
                    if (newAmount >= finalAmount) {
                        clearInterval(initialInterval);
                        reachedFinal = true;
                        return finalAmount;
                    }
                    return newAmount;
                });
            }, incrementSpeed);
            const randomIncrementInterval = setInterval(() => {
                if (reachedFinal) {
                    setJackpot((prevAmount) => {
                        const randomIncrement = Math.random() * 0.1;
                        const newAmount = prevAmount + randomIncrement;
                        if (newAmount >= finalAmount + maxIncrement) {
                            const randomSubtraction = Math.random() * 1;
                            return prevAmount - randomSubtraction;
                        }

                        return newAmount;
                    });
                }
            }, 1000);

            return () => {
                clearInterval(initialInterval);
                clearInterval(randomIncrementInterval);
            };
        };

        const cleanupMega = incrementJackpot(setMegaJackpot, finalMegaJackpot, 25, maxMegaIncrement);
        const cleanupMinor = incrementJackpot(setMinorJackpot, finalMinorJackpot, 30, maxMinorIncrement);
        const cleanupJpm = incrementJackpot(setJpmRace, finalJpmRace, 35, maxJpmIncrement);
        return () => {
            cleanupMega();
            cleanupMinor();
            cleanupJpm();
        };
    }, [finalMegaJackpot, finalMinorJackpot, finalJpmRace]);

    return (
        <>
            <div className="wrapper mx-auto pt-md-2 pt-lg-3 pt-xl-4">
                <div className='d-flex justify-content-between align-items-center mb-4'>
                    <h2 className='text-white fs-22 fw-bold m-0'><span className='opacity-50 me-2'>{icon}</span>{sectionHeading}</h2>
                </div>
                <div className='bg-castro rounded-3 position-relative overflow-hidden p-4'>
                    <div className='position-absolute d-none d-md-block start-0 top-0 bottom-0 max-w-37'>
                        <div className='h-100'>
                            <img src={jackpotbg} alt="Jackpot Bg img" className='img-fluid h-100' />
                        </div>
                    </div>
                    <div className='d-flex flex-wrap flex-md-nowrap justify-content-center gap-3'>
                        {/* Mega Jackpot Section */}
                        <div className="w-100 d-flex flex-column justify-content-center gap-3 text-center max-w-277 z-3">
                            <div className='max-w-206 mx-auto'>
                                <img src={jackpotImg} alt="Jackpot Img" className='img-fluid' />
                            </div>
                            <p className='text-white fs-16 fw-bold m-0'>
                                Play the spins for a chance to win one of the BitStarz Jackpots!
                            </p>
                        </div>

                        <div className="w-100 bg-cherrygradient rounded-3 text-center d-flex justify-content-center align-items-center z-3">
                            <div className='py-4'>
                                <p className='text-white fs-22 fw-semibold m-0'>Mega Jackpot
                                    <span className='max-w-h-23 d-inline-block ms-1'>
                                        <img src={FireEmoji} alt="Fire Emoji" className='img-fluid' />
                                    </span>
                                    <span className='max-w-h-23 d-inline-block ms-1'>
                                        <img src={FireEmoji} alt="Fire Emoji" className='img-fluid' />
                                    </span>
                                    <span className='max-w-h-23 d-inline-block ms-1'>
                                        <img src={FireEmoji} alt="Fire Emoji" className='img-fluid' />
                                    </span>
                                </p>
                                <p className='text-white fs-57 fw-bold m-0'>${megaJackpot.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                            </div>
                        </div>

                        {/* Minor Jackpot Section */}
                        <div className="w-100 d-flex flex-column justify-content-between gap-3 z-3">
                            <div className='bg-rosecherrygradient text-center w-100 h-100 rounded-3 d-flex flex-column justify-content-center align-items-center px-1 py-3'>
                                <p className='text-white fs-22 fw-semibold m-0'>Minor Jackpot
                                    <span className='max-w-h-23 d-inline-block ms-1'>
                                        <img src={FireEmoji} alt="Fire Emoji" className='img-fluid' />
                                    </span>
                                </p>
                                <p className='text-white fs-35 fw-bold m-0'>${minorJackpot.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                            </div>

                            {/* JPM Race Section */}
                            <div className='bg-deepcarminegradient text-center w-100 h-100 rounded-3 d-flex flex-column justify-content-center align-items-center px-1 py-3'>
                                <p className='text-white fs-22 fw-semibold m-0'>JPM Race
                                    <span className='max-w-h-23 d-inline-block ms-1'>
                                        <img src={FireEmoji} alt="Fire Emoji" className='img-fluid' />
                                    </span><span className='max-w-h-23 d-inline-block ms-1'>
                                        <img src={FireEmoji} alt="Fire Emoji" className='img-fluid' />
                                    </span>
                                </p>
                                <p className='text-white fs-35 fw-bold m-0'>${jpmRace.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default JackPotSlider;
